import React from 'react';
import ReactTable from "react-table";

import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import cellHeaderHOC from '../../common/Datagrid/CellHeaderHOC';
import { topTracksSettings } from './TopTracks/Settings'
const CellHeaderTable = cellHeaderHOC(ReactTable);
import { spotifyDiscoveryActions } from '../../../data/actions/spotify_discovery';
import Box from '../../common/Box';
import CSV from '../../../helpers/CSVExport';
import CatalogOverview from '../spotifyMonetization/Overview';
import Spinner from '../../common/Spinner';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');


class TopTracks extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			view: 'table'
		};
		this.exportToCsv = this.exportToCsv.bind(this);
	}
	
	componentDidMount(){
		this.props.dispatch(
			spotifyDiscoveryActions.getSpotifyDiscoveryTotals(this.props.params)
		)
	}
	
	componentWillReceiveProps(nextProps){
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				this.props.dispatch(
					spotifyDiscoveryActions.getSpotifyDiscoveryTotals(this.props.params, false)
				)
			}                
		}
		if(nextProps.params){
			if(this.props.params!==undefined && !isEqual(nextProps.params, this.props.params)) {
				this.props.dispatch(
					spotifyDiscoveryActions.getSpotifyDiscoveryTotals(nextProps.params, false)
				)
			}                
		}

	}

	
	exportToCsv(){
		let { totals = [] } = this.props.spotifyDiscovery;
		totals = totals.map(row=>{
			const { title, value, ...rest } = row;
			return { title, value };
		})
		const filename = CSV.CSVHeader('Spotify Discovery', 'Previous Period Data');
		return CSV.CSVExport(totals, {filename});
	}

	renderToolbar(){
		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		</div>)
		return toolbar;
	}

	render () {
		const { totals = [], loadingTotals } = this.props.spotifyDiscovery;
		return <React.Fragment>
			{loadingTotals && <Spinner enabled={true} className="spinner spinner-inline" />}
			{totals && <CatalogOverview stats={totals} />}
			{this.renderToolbar()}
		</React.Fragment>
	}
	
}


function mapStateToProps(state) {
	return {
		filter: state.filter,
		milestones: state.milestones,
		spotifyDiscovery: state.spotifyDiscovery 
	} 
}
export default connect(mapStateToProps)(TopTracks);